import React from 'react';

/*
 *  @Description:   Stateless component that renders a Sort Descending icon.
 */

const SortDesc = ( props ) => {

    return (
        <g>
            <path d="m12 4 5 6h-10l2.5-3z"/>
        </g>

    )

};

export default SortDesc;

